import React, { useState, useContext } from "react";
import styled from "styled-components";
import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "react-bootstrap";
import { UserContext } from "../../App";
import SearchBar from "./SearchBar";
import { logOut } from "../../store/actions/authActions";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter, NavLink, Link } from "react-router-dom";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { FaBars } from "react-icons/fa"; // Import de l'icône burger
import Logo from "../../logo.png";
import { HeaderImg, HelpMeButton } from "./asideMenu";
import useRoutes from "../../utils/useRoutes";
import MenuCreateModalButton from "./MenuCreateModalButton"; // Import du logo

const HeaderMobile = ({ logOut }) => {
  const [showMenu, setShowMenu] = useState(false);
  const { user } = useContext(UserContext);
  const { menuRoutes } = useRoutes();

  const toggleMenu = () => setShowMenu(!showMenu);

  const handleLogout = (e) => {
    e.preventDefault();
    logOut();
  };

  if (!user) return null;

  return (
    <>
      <HeaderContainer>
        <div className="d-flex align-items-center" style={{ gap: "1rem" }}>
          <MenuButton onClick={toggleMenu}>
            <FaBars size={24} />
          </MenuButton>
          <SearchBar type="text" placeholder="Search..." />
          <MenuCreateModalButton />
        </div>
        <Toolbar>
          <HelpMeButton
            data-tally-open="w828Ek"
            data-tally-layout="modal"
            data-tally-emoji-text="👋"
            data-tally-emoji-animation="wave"
            data-tally-auto-close="0"
          >
            Besoin d'aide ?
          </HelpMeButton>
          <Link to="/profile">
            <HeaderImg>
              <img
                src="https://cdn-icons-png.flaticon.com/256/6522/6522516.png"
                alt="Profile"
              />
            </HeaderImg>
          </Link>
        </Toolbar>
      </HeaderContainer>

      <Offcanvas show={showMenu} onHide={toggleMenu} placement="start">
        <OffcanvasHeader closeButton>
          <LogoContainer>
            <img src={Logo} alt="Logo" />
          </LogoContainer>
        </OffcanvasHeader>
        <OffcanvasBody>
          <MenuList>
            {menuRoutes.map((route, index) => (
              <MenuItem key={index}>
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id={`tooltip-${index}`}>{route.label}</Tooltip>
                  }
                >
                  <NavLinkStyled to={route.path}>
                    <NavIcon className={`${route.icon} nav_icon`}></NavIcon>
                    <NavLabel>{route.label}</NavLabel>
                  </NavLinkStyled>
                </OverlayTrigger>
              </MenuItem>
            ))}
          </MenuList>
          <LogoutButton onClick={handleLogout}>
            <NavIcon className="bx bx-log-out nav_icon"></NavIcon>
            <NavLabel>LogOut</NavLabel>
          </LogoutButton>
        </OffcanvasBody>
      </Offcanvas>
    </>
  );
};

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0 1rem;
  height: var(--header-height);
  background-color: #ffffff;
  
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  
  @media (min-width: 769px) {
    display: none;
  }
`;

const MenuButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  width: 100%;

  a {
    display: grid;
    place-items: center;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  img {
    max-height: 40px;
  }
`;

const MenuList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const MenuItem = styled.li`
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e0e0e0;
`;

const NavLinkStyled = styled(NavLink)`
  text-decoration: none;
  display: flex;
  align-items: center;
  color: #000;
`;

const NavIcon = styled.i`
  font-size: 2.5rem;
  margin-right: 1rem;
  min-width: 2.5rem;
  max-width: 2.5rem;
`;

const NavLabel = styled.span`
  font-size: 1rem;
`;

const LogoutButton = styled.div`
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  cursor: pointer;
  color: #000;
  margin-top: auto;
  border-top: 1px solid #e0e0e0;

  &:hover {
    background-color: #e0e0e0;
  }
`;

const mapStateToProps = (state) => {
  return {
    fbAuth: state.firebase.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logOut: () => dispatch(logOut()),
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(HeaderMobile);
